import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { DashboardConstants } from 'src/redux/actions/constant';
import templateService from 'src/services/apiServices/document-management/template-service';

const { REQUEST_SYNC_ALERTS_FROM_SIGNATURE } = DashboardConstants;

function* syncAlert(action: any): SagaReturnType<any> {
  try {
    yield call(templateService.getSyncFromSignature, action.payload);
  } catch (error) {
  }
}

function* syncAlertFromSignatureSaga() {
  yield takeEvery(REQUEST_SYNC_ALERTS_FROM_SIGNATURE, syncAlert);
}

export default syncAlertFromSignatureSaga;
